import React from "react";
import Header from "../components/header/header";
import GraphicsDesign from "../sections/GraphicsDesign/GraphicsDesign";
import Footer from "../components/footer/footer";
function Graphicdesign() {
  return (
    <>
      <Header />
      <GraphicsDesign />
      <Footer />
    </>
  );
}

export default Graphicdesign;
